import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Select as Select$1 } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
var _excluded = ["children"];

var Select = function Select(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Select$1, _extends({
    icon: /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "sort",
      size: "xs"
    })
  }, rest), children);
};

Select.displayName = "Select";
export { Select };